import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Typography, Box} from "@material-ui/core";

import Navbar from "./Navbar";

const useStyles = makeStyles(theme=>({
    mainContainer:{
        background: "rgba(255,255,255,.8)"
    }
}));

const Interests = () => {

    const classes = useStyles();

    return (
        <>
        <Navbar/>
        <Box component="header" className={classes.mainContainer}>
        <Typography>
            <h1>Interests</h1>
        </Typography>
        </Box>
        </>
    )
}

export default Interests;
